export default __webpack_public_path__ + "static/media/Loading.3381213c.svg";